export default "__VITE_ASSET__BdFjvfW0__"